/* eslint-disable */
import React, { useMemo, useRef, useState } from 'react';
import dayjs from 'dayjs';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { FaChevronDown } from 'react-icons/fa';

function FormInlineDateRange({ name, onChange, onSetFieldValue, value }) {
  const ref = useRef();
  const [open, setOpen] = useState(false);
  const CustomInput = ({ date }) => {
    const formattedValue =
      isEmpty(date) || (isEmpty(date?.start) && isEmpty(date?.end))
        ? ''
        : date?.start === dayjs().format('DD/MM/YYYY') &&
          date?.end === dayjs().format('DD/MM/YYYY')
        ? 'Today'
        : `${date?.start || ''} - ${date?.end || ''}`;
    return (
      <div
        onClick={() => setOpen(true)}
        className="flex items-center border border-gray-300 rounded-md cursor-pointer w-full p-2"
      >
        <span className="font-medium text-gray-500 mr-8">Date Range</span>
        <span className="ml-auto text-gray-500 mr-2">{formattedValue}</span>
        <FaChevronDown className="text-gray-500" />
      </div>
    );
  };
  const handleChange = (date) => {
    if (typeof onChange === 'function') {
      onChange((state) => ({
        ...state,
        [name]: {
          start: date[0] ? dayjs(date[0]).format('DD/MM/YYYY') : date[0],
          end: date[1] ? dayjs(date[1]).format('DD/MM/YYYY') : date[1],
        },
      }));
    }
    if (typeof onSetFieldValue === 'function') {
      onSetFieldValue(name, {
        start: date[0] ? dayjs(date[0]).format('DD/MM/YYYY') : date[0],
        end: date[1] ? dayjs(date[1]).format('DD/MM/YYYY') : date[1],
      });
    }
  };

  return (
    <DatePicker
      open={open}
      name={name}
      selectsRange
      customInputRef={ref}
      onClickOutside={() => setOpen(false)}
      dateFormat="dd/MM/yyyy"
      customInput={<CustomInput date={value} />}
      selected={
        value?.start
          ? dayjs(value?.start?.split('/').reverse().join('/')).toDate()
          : null
      }
      startDate={
        value?.start
          ? dayjs(value?.start?.split('/').reverse().join('/')).toDate()
          : null
      }
      endDate={
        value?.end
          ? dayjs(value?.end?.split('/').reverse().join('/')).toDate()
          : null
      }
      onChange={handleChange}
    />
  );
}

FormInlineDateRange.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.oneOfType([
    PropTypes.instanceOf(Function),
    PropTypes.bool,
  ]),
  onSetFieldValue: PropTypes.oneOfType([
    PropTypes.instanceOf(Function),
    PropTypes.bool,
  ]),
  value: PropTypes.instanceOf(Object).isRequired,
};

FormInlineDateRange.defaultProps = {
  onChange: false,
  onSetFieldValue: false,
};

export default FormInlineDateRange;
